import Grid from "@mui/material/Unstable_Grid2";

function GridContainer(props) {
    return <Grid
        container
        spacing={2}
        sx={(theme) => ({
            margin: '1rem',
            maxWidth: theme.breakpoints.values.lg,
            mx: 'auto',
            // Allow consumers to extend/override styles
            ...(typeof props.sx === 'function' ? props.sx(theme) : props.sx),
        })}
        {...props}
    />
}

export default GridContainer
